export * as linkStyleConfigs from './style-configs';
export { Link } from './link';
export type { LinkProps } from './types';
